export default "__VITE_ASSET__CTb2DnVy__"